import { PermissionEnum } from '@Application/Security/Roles';
import LimitBlock from '@UI/Pages/Administration/AiCosts/CostSummary/MonthlyLimit/LimitBlock';
import type AiCostsFilterView from '@UI/Pages/Administration/AiCosts/Filters/AiCostsFilterView';
import WithPermission from '@UI/Providers/PermissionProvider/WithPermission';
import type AiCostSummaryView from '@UI/Store/AiCosts/Views/AiCostSummaryView';
import type * as React from 'react';

type Props = {
	readonly accountId: number;
	readonly summary: AiCostSummaryView;
	readonly filters: AiCostsFilterView;
};

/** The limits are only read, and the block only shown, to those who may manage them. */
const MonthlyLimit: React.FC<Props> = ({ accountId, summary, filters }) => {
	return (
		<WithPermission permission={PermissionEnum.AI_COST_LIMIT_WRITE}>
			<LimitBlock accountId={accountId} summary={summary} filters={filters} />
		</WithPermission>
	);
};

export default MonthlyLimit;
